<template>
    <section class="popular-models">
        <template v-if="!loadingModels && !errorModels">
            <div v-if="models.length > 0" class="models">
                <ModelBox
                    class="model"
                    v-for="model in models"
                    :model="model"
                    :key="model.id"
                />
            </div>
            <template v-else>
                <div class="no-data">
                    {{$t('noRecordsFound')}}
                </div>
            </template>
        </template>
        <template v-else>
            <Spinner v-if="loadingModels"/>
            <template v-if="errorModels">
                <p>
                    {{$t('error')}}
                </p>
                <button
                    type="button"
                    @click="loadModels"
                >
                    {{$t('retry')}}
                </button>
            </template>
        </template>
    </section>
</template>
<script>
import ModelBox from './Home/ModelBoxUgly'
import Spinner from "./Spinner"

export default {
    name: 'GridModelsContainer',
    components: {ModelBox, Spinner},
    props: {
        errorModels: {},
        loadModels: {},
        loadingModels: {},
        models: {}
    }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';

.popular-models {
    .models{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-block: 5px;

        .model{}
    }

    .more{
        display: block;
        border: 2px solid var(--pallete_main_color);
        line-height: 1.5;
        color: var(--pallete_main_color);
        text-align: center;
        font-size: 1.7em;
        margin: 15px 0;
        font-family: Arial;
        border-radius: 30px;
        transition: 200ms;
        text-transform: uppercase;

        &:hover{
            background: var(--pallete_main_color);
            color: #ffffff;
        }

        &.more-footer{
            width: 300px;
            line-height: 2;
            @media(max-width: 960px){
                margin: 15px auto;
            }
        }
    }
  
  .no-data{
    color: var(--pallete_main_color);
    text-align: center;
    font-size: 1.7em;
  }
}
</style>